import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';

// API routes now require auth — attach the JWT to every same-origin request
axios.interceptors.request.use((config) => {
  const url = config.url || '';
  const sameOrigin = url.startsWith('/') || url.startsWith(window.location.origin);
  const token = localStorage.getItem('token');
  if (token && sameOrigin && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Expired/invalid session: clear it and return to the dashboard login
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/dashboard/';
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
